import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 overflow-x-auto min-h-[420px]"
}
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_4 = {
  scope: "col",
  class: "w-16 px-2 py-2"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = { class: "relative flex flex-wrap items-center justify-between w-full" }
const _hoisted_8 = {
  scope: "col",
  class: "w-40 px-2 py-2"
}
const _hoisted_9 = { class: "relative flex flex-wrap items-center justify-between w-full" }
const _hoisted_10 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_11 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_12 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_13 = { class: "flex items-center justify-between px-2 py-2" }
const _hoisted_14 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_15 = { class: "relative flex flex-wrap items-center justify-between w-full" }
const _hoisted_16 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_17 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_18 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_19 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_20 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_21 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_23 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_26 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_27 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_28 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_29 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_30 = { class: "relative flex flex-wrap items-center justify-between w-full" }
const _hoisted_31 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_32 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_33 = { class: "relative flex flex-wrap items-center justify-between w-full" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_35 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_36 = { class: "px-2 py-3 capitalize" }
const _hoisted_37 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_38 = { class: "px-2 py-2 capitalize" }
const _hoisted_39 = { class: "px-2 py-2 text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_40 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_41 = { class: "px-2 py-2 capitalize" }
const _hoisted_42 = { class: "px-2 py-2 capitalize" }
const _hoisted_43 = { class: "px-2 py-2 capitalize" }
const _hoisted_44 = { class: "px-2 py-2 capitalize" }
const _hoisted_45 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_46 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_47 = { class: "px-2 py-2 capitalize" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "px-2 py-2 capitalize" }
const _hoisted_50 = { class: "px-2 py-2" }
const _hoisted_51 = {
  key: 1,
  class: "mt-4 overflow-x-auto min-h-[420px]"
}
const _hoisted_52 = { class: "w-full table-auto" }
const _hoisted_53 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_54 = {
  scope: "col",
  class: "w-16 px-2 py-2"
}
const _hoisted_55 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_56 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_57 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_58 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_59 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_60 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_61 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_62 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_63 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_64 = {
  scope: "col",
  class: "w-48 px-2 py-2"
}
const _hoisted_65 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_66 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_67 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_68 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_69 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_70 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_71 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_72 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_73 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_74 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_75 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_76 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_77 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_78 = {
  key: 0,
  class: "flex items-center justify-between px-2 py-2"
}
const _hoisted_79 = { class: "px-2 py-3 capitalize" }
const _hoisted_80 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_81 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_82 = { class: "px-2 py-2 capitalize" }
const _hoisted_83 = { class: "px-2 py-2 capitalize" }
const _hoisted_84 = { class: "px-2 py-2 capitalize" }
const _hoisted_85 = { class: "px-2 py-2 capitalize" }
const _hoisted_86 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_87 = { class: "px-2 py-2 capitalize" }
const _hoisted_88 = { key: 0 }

import { ref, watch } from "vue";
import { useRoute } from "vue-router";

import Tabs from "../TabGroup.vue";
import PaginationBar from "../PaginationBar.vue";
import ToggleCheckbox from "../ToggleCheckbox.vue";
import FilterTableHeader from "./FilterTableHeader.vue";
import PaymentStatusBadge from "../PaymentStatusBadge.vue";
import SortableTableHeader from "./SortableTableHeader.vue";

import api from "@/api/api";
import { useGlobalStore } from "@/store";
import { Booking, Organisation, Transaction } from "@/types";
import { useFilters } from "@/composables/filters";
import SearchTableHeader from "./SearchTableHeader.vue";
import TransactionBadge from "../TransactionBadge.vue";
// import SearchSubOrgTableHeader from "./SearchSubOrgTableHeader.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrdersTable',
  props: {
  showFilters: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();

const tabs = [
  { id: "bookings", name: "Bookings" },
  { id: "one-off-products", name: "One-off fee Product" },
];
const selectedTab = ref("bookings");



const dateFilters = ["week", "month"];
const typesFilter = ["single", "group"];
const statusFilters = ["abandoned", "confirmed", "pending", "refunded"];
const oneOffStatusFilters = ["Paid", "Pending"];
const paymentMethodsFilter = ["Credit/Debit Card", "Free", "Invoice", "Licence", "Manual"];

const templates = ref([] as string[]);
const events = ref([] as any[]);

const { filters, getFiltersFromQuery, resetFilters, sortBy, setFilter, setFilterNoRefresh } = useFilters(route);

const trainedByOrganisations = ref([] as string[]);
const subOrganisations = ref([] as string[]);
const transactions = ref([] as Transaction[]);
const orders = ref([] as Booking[]);
const meta = ref({} as any);
const users = ref([] as { key: string; value: string }[]);
const emails = ref([] as { key: string; value: string }[]);

function updateSelectedTab(tab: string) {
  selectedTab.value = tab;
  setFilterNoRefresh("tab", tab);
  search();
}

async function markAsInvoiceIssued(id: number) {
  try {
    const response = await api.bookings.toggleBookingInvoiceIssued(id);

    const issued = response.data.booking.invoice_issued ? "issued" : "not issued";
    await search();

    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function markAsInvoiceAsPaid(booking: Booking) {
  try {
    const response = await api.bookings.updateBookingPayment(booking.id, { payment_confirmed: booking.payment_confirmed });

    const paid = response?.data.booking.payment_status === "confirmed" ? "Paid" : "Unpaid";
    await search();

    globalStore.toast("SUCCESS", `Invoice marked as ${paid}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function fetchEvents() {
  const response = await api.events.listEvents({ page: "all", status: "published" });
  events.value = response.data.events;

  // Fetch name from event.name, we only want unique names
  templates.value = response.data.events
    .map((event: any) => event.name)
    .filter((name: string, index: number, self: any) => self.indexOf(name) === index)
    .sort((a: string, b: string) => a.localeCompare(b));
}

async function search() {
  let response: any = {};

  if (selectedTab.value === "bookings") {
    response = await api.bookings.listBookings({
      ...filters.value,
      play_event: true,
    });
    orders.value = response.data.bookings;
  }

  if (selectedTab.value === "one-off-products") {
    response = await api.bookings.listTransactions(filters.value as any);
    transactions.value = response.data.transactions;
  }

  meta.value = response.meta;
  emails.value = response.data.users
    .map((user: any) => {
      return { key: user.email, value: user.id };
    })
    .sort((a: any, b: any) => a.value - b.value)
    .filter((user: any, index: number, self: any) => self.findIndex((u: any) => u.value === user.value) === index);

  users.value = response.data.users
    .map((user: any) => {
      return { key: user.name, value: user.id };
    })
    .sort((a: any, b: any) => a.value - b.value)
    .filter((user: any, index: number, self: any) => self.findIndex((u: any) => u.value === user.value) === index);
}

selectedTab.value = (route.query.tab as string) || "bookings";
trainedByOrganisations.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.organisations.listOrganisations({ page: "all" }))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.organisations.map((o: Organisation) => {
  return o.name;
});

subOrganisations.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.organisations.listSubOrganisations())),
  __temp = await __temp,
  __restore(),
  __temp
)).data.sub_organisations;

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

;(
  ([__temp,__restore] = _withAsyncContext(() => fetchEvents())),
  await __temp,
  __restore()
);

watch(route.query, () => {
  if (route.query.tab !== "bookings") {
    setFilterNoRefresh("tab", "bookings");
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Tabs, {
        tabs: tabs,
        "selected-tab": selectedTab.value,
        onSelect: updateSelectedTab
      }, null, 8, ["selected-tab"])
    ]),
    (selectedTab.value === 'bookings' && orders.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                _createElementVNode("th", _hoisted_4, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("order-no")), 1),
                  (_ctx.$props.showFilters)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(SortableTableHeader, {
                          column: "id",
                          onSort: _unref(sortBy)
                        }, null, 8, ["onSort"])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("th", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`placed`)), 1),
                    _createVNode(SortableTableHeader, {
                      column: "created_at",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "timeframe",
                          currentValue: _unref(filters).timeframe,
                          filters: dateFilters,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("event-id")), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(SortableTableHeader, {
                            column: "event_id",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"]),
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(FilterTableHeader, {
                                key: 0,
                                label: "event_id",
                                currentValue: _unref(filters).event_id,
                                isObjectArray: true,
                                filters: events.value.map(event => ({ key: event.id, value: event.id })),
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "filters", "onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("event-name")), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(FilterTableHeader, {
                        currentValue: _unref(filters).event_name,
                        label: "event_name",
                        filters: templates.value,
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["currentValue", "filters", "onChange", "onReset"])
                    ])
                  ])
                ]),
                _createElementVNode("th", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`event-date`)), 1),
                    _createVNode(SortableTableHeader, {
                      column: "event.first_event_date",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"])
                  ])
                ]),
                _createElementVNode("th", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`name`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(SearchTableHeader, {
                          key: 0,
                          display_property: "name",
                          search_term: "last_name",
                          label: "user_id",
                          filter_property: "id",
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`email`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(SearchTableHeader, {
                          key: 0,
                          display_property: "email",
                          search_term: "email",
                          label: "user_id",
                          filter_property: "id",
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`trained-by`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "organisation_id",
                          currentValue: _unref(filters).organisation_id,
                          filters: trainedByOrganisations.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`organisation`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          currentValue: _unref(filters).sub_organisation,
                          label: "sub_organisation",
                          filters: subOrganisations.value,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "filters", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "type",
                          currentValue: _unref(filters).type,
                          filters: typesFilter,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-method`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(SortableTableHeader, {
                            column: "payment_gateway",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"]),
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(FilterTableHeader, {
                                key: 0,
                                label: "method",
                                currentValue: _unref(filters).method,
                                filters: paymentMethodsFilter,
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`invoice-issued`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                          _createVNode(SortableTableHeader, {
                            column: "invoice_issued",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"]),
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(FilterTableHeader, {
                                key: 0,
                                label: "invoice_issued",
                                currentValue: _unref(filters).invoice_issued,
                                filters: ['true', 'false'],
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`paid`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                          _createVNode(SortableTableHeader, {
                            column: "payment_status",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"]),
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(FilterTableHeader, {
                                key: 0,
                                label: "status",
                                currentValue: _unref(filters).status,
                                filters: statusFilters,
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.$t("actions")), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(orders.value, (order) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b border-gray-400 divide-x divide-gray-300",
                  key: order.id
                }, [
                  _createElementVNode("td", _hoisted_36, _toDisplayString(order.id), 1),
                  _createElementVNode("td", _hoisted_37, _toDisplayString(new Date(order.created_at).toDateString()), 1),
                  _createElementVNode("td", _hoisted_38, _toDisplayString(order.event?.id), 1),
                  _createElementVNode("td", _hoisted_39, [
                    _createVNode(_component_router_link, {
                      to: `/dashboard/courses/events/${order.event?.id}`
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(order.event?.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", _hoisted_40, _toDisplayString(order.event?.first_event_date ? new Date(order.event?.first_event_date).toDateString() : null), 1),
                  _createElementVNode("td", _hoisted_41, _toDisplayString(order.user.first_name) + " " + _toDisplayString(order.user.last_name), 1),
                  _createElementVNode("td", _hoisted_42, _toDisplayString(order.user.email), 1),
                  _createElementVNode("td", _hoisted_43, _toDisplayString(order.organisation ? order.organisation.name : null), 1),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(order?.sub_organisation ?? order?.user?.sub_organisation ?? null), 1),
                  _createElementVNode("td", _hoisted_45, _toDisplayString(order.type === "single" ? _ctx.$t("single-booking") : _ctx.$t("group-booking")), 1),
                  _createElementVNode("td", _hoisted_46, _toDisplayString(order.payment_method === "License" ? "Licence" : order.payment_method) + " " + _toDisplayString(order.payment_method === "Credit/Debit Card" && order.payment_gateway ? `(${order.payment_gateway})` : ""), 1),
                  _createElementVNode("td", _hoisted_47, [
                    (order.payment_method !== 'Invoice')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_48))
                      : (_openBlock(), _createBlock(ToggleCheckbox, {
                          key: 1,
                          value: order.invoice_issued,
                          onToggle: ($event: any) => (markAsInvoiceIssued(order.id))
                        }, null, 8, ["value", "onToggle"]))
                  ]),
                  _createElementVNode("td", _hoisted_49, [
                    (order.payment_method !== 'Invoice' || order.payment_status === 'refunded')
                      ? (_openBlock(), _createBlock(PaymentStatusBadge, {
                          key: 0,
                          order: order
                        }, null, 8, ["order"]))
                      : (_openBlock(), _createBlock(ToggleCheckbox, {
                          key: 1,
                          value: order.payment_confirmed,
                          onToggle: ($event: any) => (markAsInvoiceAsPaid(order))
                        }, null, 8, ["value", "onToggle"]))
                  ]),
                  _createElementVNode("td", _hoisted_50, [
                    _createVNode(_component_router_link, {
                      to: `/dashboard/courses/events/${order.event_id}/bookings/${order.id}`,
                      class: "text-blue"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("view")), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_ctx.$props.showFilters)
            ? (_openBlock(), _createBlock(PaginationBar, {
                key: 0,
                meta: meta.value
              }, null, 8, ["meta"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (selectedTab.value === 'one-off-products')
      ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
          _createElementVNode("table", _hoisted_52, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_53, [
                _createElementVNode("th", _hoisted_54, _toDisplayString(_ctx.$t("payment-gateway-order-id")), 1),
                _createElementVNode("th", _hoisted_55, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`placed`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                          _createVNode(SortableTableHeader, {
                            column: "created_at",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_58, [
                  _createElementVNode("div", _hoisted_59, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("type")), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                          _createVNode(SortableTableHeader, {
                            column: "type",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_61, [
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`name`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(SearchTableHeader, {
                                key: 0,
                                display_property: "name",
                                search_term: "last_name",
                                label: "user_id",
                                filter_property: "id",
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`email`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(SearchTableHeader, {
                          key: 0,
                          display_property: "email",
                          search_term: "email",
                          label: "user_id",
                          filter_property: "id",
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t(`trained-by`)), 1),
                      (_ctx.$props.showFilters)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                            _createVNode(SortableTableHeader, {
                              column: "organisation.name",
                              onSort: _unref(sortBy)
                            }, null, 8, ["onSort"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("th", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`organisation`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                          _createVNode(SortableTableHeader, {
                            column: "sub_organisation",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_73, [
                  _createElementVNode("div", _hoisted_74, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-method`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _createVNode(SortableTableHeader, {
                            column: "payment_gateway",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("th", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`status`)), 1),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          _createVNode(SortableTableHeader, {
                            column: "status",
                            onSort: _unref(sortBy)
                          }, null, 8, ["onSort"]),
                          (_ctx.$props.showFilters)
                            ? (_openBlock(), _createBlock(FilterTableHeader, {
                                key: 0,
                                label: "status",
                                currentValue: _unref(filters).status,
                                filters: oneOffStatusFilters,
                                onChange: _unref(setFilter),
                                onReset: _unref(resetFilters)
                              }, null, 8, ["currentValue", "onChange", "onReset"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transactions.value, (transaction) => {
                return (_openBlock(), _createElementBlock("tr", {
                  class: "border-b border-gray-400 divide-x divide-gray-300",
                  key: transaction.id
                }, [
                  _createElementVNode("td", _hoisted_79, _toDisplayString(transaction.payment_gateway_ref), 1),
                  _createElementVNode("td", _hoisted_80, _toDisplayString(new Date(transaction.created_at).toDateString()), 1),
                  _createElementVNode("td", _hoisted_81, _toDisplayString(transaction.type === "PaidProfessional" ? "BrickClubBasics" : transaction.type), 1),
                  _createElementVNode("td", _hoisted_82, [
                    _createVNode(_component_router_link, {
                      to: `/dashboard/users/${transaction.user_id}`,
                      class: "text-blue-500"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(transaction.user.first_name) + " " + _toDisplayString(transaction.user.last_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", _hoisted_83, [
                    _createVNode(_component_router_link, {
                      to: `/dashboard/users/${transaction.user_id}`,
                      class: "text-blue-500"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(transaction.user.email), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("td", _hoisted_84, _toDisplayString(transaction.user.organisation ? transaction.user.organisation.name : ""), 1),
                  _createElementVNode("td", _hoisted_85, _toDisplayString(transaction.user.sub_organisation ? transaction.user.sub_organisation : "N/A"), 1),
                  _createElementVNode("td", _hoisted_86, _toDisplayString(transaction.payment_gateway), 1),
                  _createElementVNode("td", _hoisted_87, [
                    (transaction.payment_gateway !== 'Invoice')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_88, [
                          _createVNode(TransactionBadge, { transaction: transaction }, null, 8, ["transaction"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          (_ctx.$props.showFilters)
            ? (_openBlock(), _createBlock(PaginationBar, {
                key: 0,
                meta: meta.value
              }, null, 8, ["meta"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})